/* tslint:disable */
/* eslint-disable */
/**
 * GLC.ClientPortal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PagingArgs } from './PagingArgs';
import {
    PagingArgsFromJSON,
    PagingArgsFromJSONTyped,
    PagingArgsToJSON,
} from './PagingArgs';

/**
 * 
 * @export
 * @interface IntermediaryClientPlanDetailsRequest
 */
export interface IntermediaryClientPlanDetailsRequest {
    /**
     * 
     * @type {string}
     * @memberof IntermediaryClientPlanDetailsRequest
     */
    bookOfBusinessCodeList?: string;
    /**
     * 
     * @type {string}
     * @memberof IntermediaryClientPlanDetailsRequest
     */
    intermediaryCodeTableType?: string;
    /**
     * 
     * @type {string}
     * @memberof IntermediaryClientPlanDetailsRequest
     */
    clientNumberTableType?: string;
    /**
     * 
     * @type {string}
     * @memberof IntermediaryClientPlanDetailsRequest
     */
    planNumberTableType?: string;
    /**
     * 
     * @type {Date}
     * @memberof IntermediaryClientPlanDetailsRequest
     */
    effectiveDate?: Date;
    /**
     * 
     * @type {number}
     * @memberof IntermediaryClientPlanDetailsRequest
     */
    resultLimit?: number;
    /**
     * 
     * @type {string}
     * @memberof IntermediaryClientPlanDetailsRequest
     */
    planActiveFlag?: string;
    /**
     * 
     * @type {string}
     * @memberof IntermediaryClientPlanDetailsRequest
     */
    jockeyFlag?: string;
    /**
     * 
     * @type {string}
     * @memberof IntermediaryClientPlanDetailsRequest
     */
    exBrokerFlag?: string;
    /**
     * 
     * @type {PagingArgs}
     * @memberof IntermediaryClientPlanDetailsRequest
     */
    pagingArgs?: PagingArgs;
    /**
     * 
     * @type {string}
     * @memberof IntermediaryClientPlanDetailsRequest
     */
    searchTerm?: string;
    /**
     * 
     * @type {boolean}
     * @memberof IntermediaryClientPlanDetailsRequest
     */
    distinctClientSearch?: boolean;
}

/**
 * Check if a given object implements the IntermediaryClientPlanDetailsRequest interface.
 */
export function instanceOfIntermediaryClientPlanDetailsRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function IntermediaryClientPlanDetailsRequestFromJSON(json: any): IntermediaryClientPlanDetailsRequest {
    return IntermediaryClientPlanDetailsRequestFromJSONTyped(json, false);
}

export function IntermediaryClientPlanDetailsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): IntermediaryClientPlanDetailsRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'bookOfBusinessCodeList': !exists(json, 'BookOfBusinessCodeList') ? undefined : json['BookOfBusinessCodeList'],
        'intermediaryCodeTableType': !exists(json, 'IntermediaryCodeTableType') ? undefined : json['IntermediaryCodeTableType'],
        'clientNumberTableType': !exists(json, 'ClientNumberTableType') ? undefined : json['ClientNumberTableType'],
        'planNumberTableType': !exists(json, 'PlanNumberTableType') ? undefined : json['PlanNumberTableType'],
        'effectiveDate': !exists(json, 'EffectiveDate') ? undefined : (new Date(json['EffectiveDate'])),
        'resultLimit': !exists(json, 'ResultLimit') ? undefined : json['ResultLimit'],
        'planActiveFlag': !exists(json, 'PlanActiveFlag') ? undefined : json['PlanActiveFlag'],
        'jockeyFlag': !exists(json, 'JockeyFlag') ? undefined : json['JockeyFlag'],
        'exBrokerFlag': !exists(json, 'ExBrokerFlag') ? undefined : json['ExBrokerFlag'],
        'pagingArgs': !exists(json, 'PagingArgs') ? undefined : PagingArgsFromJSON(json['PagingArgs']),
        'searchTerm': !exists(json, 'SearchTerm') ? undefined : json['SearchTerm'],
        'distinctClientSearch': !exists(json, 'DistinctClientSearch') ? undefined : json['DistinctClientSearch'],
    };
}

export function IntermediaryClientPlanDetailsRequestToJSON(value?: IntermediaryClientPlanDetailsRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'BookOfBusinessCodeList': value.bookOfBusinessCodeList,
        'IntermediaryCodeTableType': value.intermediaryCodeTableType,
        'ClientNumberTableType': value.clientNumberTableType,
        'PlanNumberTableType': value.planNumberTableType,
        'EffectiveDate': value.effectiveDate === undefined ? undefined : (value.effectiveDate.toISOString()),
        'ResultLimit': value.resultLimit,
        'PlanActiveFlag': value.planActiveFlag,
        'JockeyFlag': value.jockeyFlag,
        'ExBrokerFlag': value.exBrokerFlag,
        'PagingArgs': PagingArgsToJSON(value.pagingArgs),
        'SearchTerm': value.searchTerm,
        'DistinctClientSearch': value.distinctClientSearch,
    };
}

